import { MessageSquare } from "lucide-react";
import { cn } from "@/lib/utils";

export function CommentBadge({
  count,
  carryOver = 0,
  className,
}: {
  count: number;
  carryOver?: number;
  className?: string;
}) {
  const total = count + carryOver;
  if (total === 0) return null;
  return (
    <div
      className={cn(
        "absolute -top-2 -right-2 z-10 rounded-full px-1.5 py-0.5 text-[10px] font-medium flex items-center gap-1 border bg-warning-soft text-warning-ink border-warning/30",
        className,
      )}
      title={
        carryOver > 0
          ? `${count} on this version, ${carryOver} carried over`
          : `${count} comment${count === 1 ? "" : "s"}`
      }
    >
      <MessageSquare className="h-2.5 w-2.5" />
      <span>{total}</span>
    </div>
  );
}
